<template>
  <div v-loading="loading">
    <!-- 订单信息 -->
    <order-info :info="info" type="2" :list="infoList" :sub-status="$route.query.subStatus" />
    <!-- 生产能力保障审查 -->
    <capability-review
      v-if="$route.query.isStructured === '1' && type === '1'"
      ref="capability"
      @setScore="setScore"
      @getTableData="getTableData"
    />
    <!-- 检测内容和结果 产品性能测试得分-->
    <detection-content
      v-if="$route.query.isStructured === '1' && type === '2'"
      ref="detection"
      :apply-item-price-grade-remark="applyItemPriceGradeRemark"
      :apply-item-price-id-set="applyItemPriceIdSet"
      @setScore="setScore"
      @getResultOrCore="getResultOrCore"
    />
    <!-- 评价信息 -->
    <evaluative-info
      ref="evaluative"
      :type="type"
      :is-structured="$route.query.isStructured"
      :list="evaluationApplyList"
    />
    <el-row class="form-container">
      <div class="el-descriptions-title">产品质量评价申请人信息</div>
      <apply-info :apply-info="info"></apply-info>
    </el-row>
    <div style="text-align: right">
      <eui-btn
        v-if="$route.query.isStructured === '1' && type === '1'"
        v-debounce="() => onSubmit(0)"
        type="secondary"
        class="margin-r10"
      >
        保 存
      </eui-btn>
      <eui-btn
        v-if="$route.query.isStructured === '1'"
        type="secondary"
        class="margin-r10"
        @click="downloadSiteReviewReport"
      >
        下载现场审查报告
      </eui-btn>
      <eui-btn
        v-if="$route.query.isStructured === '1' && type === '2'"
        type="secondary"
        class="margin-r10"
        @click="downloadProductTestReport"
      >
        下载实物检测报告
      </eui-btn>
      <eui-btn v-debounce="() => onSubmit(1)" type="primary">提 交</eui-btn>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/ESorganization';
import bus from '@/components/common/bus';
import utils from '@/modules/projectA/utils/utils';
import orderInfo from '../components/orderInfo';
import evaluativeInfo from './components/evaluativeInfo';
import capabilityReview from './components/capabilityReview';
import detectionContent from './components/detectionContent';
import applyInfo from '../ESapply/component/applyInfo.vue';

export default {
  name: 'Enter',
  components: {
    orderInfo,
    evaluativeInfo,
    capabilityReview,
    applyInfo,
    detectionContent,
  },
  data() {
    return {
      info: {
        evaluationCode: '',
        evaluateMethodName: '',
        className: '',
        auditStatus: '',
        refuseAuditLogVO: {},
      },
      evaluationApplyList: [],
      infoList: [
        { label: '评价办法', key: 'evaluateMethodName' },
        { label: '产品类目', key: 'className' },
        { label: 'EQE编码', key: 'evaluationCode' },
      ],
      score: '',
      applyItemPriceId: '',
      applyItemPriceIdSet: [],
      loading: false,
      applyItemPriceGradeRemark: '',
    };
  },
  computed: {
    type() {
      // 现场审查
      if (['1', '7', '10'].includes(this.$route.query.subStatus)) {
        return '1';
      }
      // 实物检测
      if (['2', '6', '11'].includes(this.$route.query.subStatus)) {
        return '2';
      }
      return '';
    },
  },
  created() {
    const { allId } = this.$route.query;
    if (typeof allId === 'string') {
      this.applyItemPriceId = allId;
      this.applyItemPriceIdSet = [allId];
    } else {
      this.applyItemPriceId = allId[0];
      this.applyItemPriceIdSet = allId;
    }
    this.getData();
  },
  methods: {
    getResultOrCore() {
      console.log('组件实例:', this.$refs.detection);
      const { performanceTableData, tableData, remark } = this.$refs.detection;
      const performanceTableDataAl = JSON.parse(JSON.stringify(performanceTableData));
      console.log(performanceTableData, tableData, remark);
      const { evaluationItemId } = this.$route.query;
      const obj = {
        applyItemPriceId: this.applyItemPriceId,
        evaluationItemId,
        applyProductBenchmarkAOList: [],
        applyProductPerformanceAOList: [],
        remark,
      };
      const applyProductPerformanceAOList = tableData.map((item) => ({
        detectResult: item.detectResult,
        qualifiedSign: item.qualifiedSign,
        evaluationProductPerformanceId: item.id,
      }));
      /* const applyProductBenchmarkAOList = data1
        .filter((item) => !item.hidden && Object.hasOwn(item, 'realScore'))
        .map((item) => ({
          evaluationProductPerformanceId: item.evaluationProductId,
          realScore: item.realScore,
          realTestVal: item.realTestVal,
          remark: item.realRemark,
        })); */

      const applyProductBenchmarkAOObj = performanceTableDataAl.reverse().reduce((acc, current) => {
        if (!acc[current.evaluationProductPerformanceId]) {
          acc[current.evaluationProductPerformanceId] = { ...current };
        } else {
          // 如果存在相同id的对象，则合并当前对象的属性
          Object.assign(acc[current.evaluationProductPerformanceId], current);
        }
        return acc;
      }, {});

      const applyProductBenchmarkAOList = Object.values(applyProductBenchmarkAOObj)
        .filter((item) => !item.hidden && Object.hasOwn(item, 'realScore'))
        .map((item) => ({
          evaluationProductPerformanceId: item.evaluationProductPerformanceId,
          realScore: item.realScore,
          realTestVal: item.realTestVal,
          remark: item.realRemark,
        }));

      console.log('applyProductBenchmarkAOList:', applyProductBenchmarkAOList);

      obj.applyProductBenchmarkAOList = applyProductBenchmarkAOList;
      obj.applyProductPerformanceAOList = applyProductPerformanceAOList;

      return obj;
    },

    async downloadProductTestReport() {
      const params = this.getResultOrCore();
      const result = await Api.downloadProductTestReport(params);
      if (result.type === 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        utils.downFile(result, '名字', '.pdf');
      }
    },
    getTableData(data) {
      console.log('getTableData:', data);
      const { applyId, evaluationItemId, allId: applyItemPriceId } = this.$route.query;

      const obj = {
        applyId,
        evaluationItemId,
        applyItemPriceId,
        evaluationProduceAbilityList: [],
      };
      data.forEach((firstItem) => {
        const { ability: firstLevelName, score: firstLevelScore } = firstItem;
        const item = {
          firstLevelName,
          firstLevelScore,
        };
        firstItem.list.forEach((secondItem, secondIndex) => {
          item.firstLevelNo = secondIndex + 1;
          /* 
            "secondLevelId": 13,
            "secondLevelName": "协作情况",
            "secondLevelScore": "6",
          */
          item.secondLevelName = secondItem.parentAbility;
          item.secondLevelScore = secondItem.parentScore;
          item.secondLevelId = secondItem.abilityId;
          /* 
            "ability": "冷加工能力",
            "score": "2",
            "grade": "1",
            "review": "评审情况测试数据",
            "advice": "这是备注"
          */

          item.ability = secondItem.ability;
          item.score = secondItem.score;
          item.grade = secondItem.grade;
          item.review = secondItem.review;
          item.advice = secondItem.advice;

          obj.evaluationProduceAbilityList.push(item);
        });
        console.log('obj:', obj);
        this.downloadSiteReviewReportData = obj;
      });
    },
    async downloadSiteReviewReport() {
      const result = await Api.downloadSiteReviewReport(this.downloadSiteReviewReportData);
      if (result.type === 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        utils.downFile(result, '名字', '.pdf');
      }
    },
    /**
     * 设置现场审查分数
     * @param v
     */
    setScore(v) {
      const data = this.evaluationApplyList[0];
      // 现场审查
      if (this.type === '1') {
        // 评价信息接口已经返回
        if (data) {
          this.$set(this.evaluationApplyList[0], 'fieldReview', v.toFixed(2));
        } else {
          // 如果评价信息接口还没返回，先记录
          this.score = v.toFixed(2);
        }
      } else if (data) {
        let grade = '';
        const { fieldReview, sceneCheckWeight, entityCheckWeight } = data;
        const compositeScore =
          (Number(fieldReview) * sceneCheckWeight) / (sceneCheckWeight + entityCheckWeight) +
          (Number(v) * entityCheckWeight) / (sceneCheckWeight + entityCheckWeight);
        this.$set(this.evaluationApplyList[0], 'productTest', v);
        this.$set(this.evaluationApplyList[0], 'compositeScore', compositeScore.toFixed(2));
        if (compositeScore >= 96) {
          grade = 'AAA';
        } else if (compositeScore >= 93) {
          grade = 'AA';
        } else if (compositeScore >= 90) {
          grade = 'A';
        } else if (compositeScore >= 85) {
          grade = 'BBB';
        } else if (compositeScore >= 80) {
          grade = 'BB';
        } else if (compositeScore >= 75) {
          grade = 'B';
        } else if (compositeScore >= 70) {
          grade = 'CCC';
        } else if (compositeScore >= 65) {
          grade = 'CC';
        } else if (compositeScore >= 60) {
          grade = 'C';
        } else {
          grade = '不合格';
        }
        this.$set(this.evaluationApplyList[0], 'grade', grade);
      } else {
        // 如果评价信息接口还没返回，先记录
        // this.score = v?.toFixed(2);
      }

      console.log('evaluationApplyList:', v);
    },
    getData() {
      const { evaluationItemId, applyId } = this.$route.query;
      this.loading = true;
      Api.getEvaluationApplyGradeDetail({
        applyId,
        evaluationItemId,
        applyItemPriceId: this.applyItemPriceId,
        applyItemPriceIdSet: this.applyItemPriceIdSet,
      }).then((res) => {
        if (res.code === '200') {
          const list = res.data.evaluationApplyItemPriceVOList || [];
          // 接口返回时，用户已经数据评分
          if (this.score) {
            list[0].fieldReview = this.score;
          }
          this.evaluationApplyList = list;
          this.applyItemPriceGradeRemark = list[0].applyItemPriceGradeRemark;
          this.info = {
            ...list[0],
            ...res.data,
          };
        }
        this.loading = false;
      });
    },
    /**
     * 提交或保存
     * @param submitType 0:保存，1:提交
     * @returns {Promise<void>}
     */
    async onSubmit(submitType) {
      const { evaluateItemPriceId, evaluationItemId, supplierType, isStructured, applyId } = this.$route.query;
      const error = [];
      const reg = /^\d+(\.\d{1,2})?$/;
      const info = this.$refs.evaluative.tableData[0];
      const list = [];
      const applyProductBenchmarkAOList = [];
      let applyProductPerformanceAOList = [];
      // 现场审核
      if (this.type === '1') {
        if (!info?.sceneReportAttachPath) {
          error.push('请上传现场审查报告(pdf格式)');
        }
        // 非结构化
        if (isStructured === '0') {
          if (!reg.test(info?.fieldReview) || Number(info?.fieldReview) > 100 || Number(info?.fieldReview) < 0) {
            error.push('现场审查分数不合理');
          }
        } else {
          const capability = this.$refs.capability.tableData;
          capability.forEach((item) => {
            const { id, ability, abilityId, abilityParentId, level, path, remark, score, sortNum, children } = item;
            list.push({
              id,
              ability,
              abilityId,
              abilityParentId,
              level,
              path,
              remark,
              score,
              sortNum,
            });
            children?.forEach((item2) => {
              const { id, ability, abilityId, abilityParentId, level, path, remark, score, sortNum } = item2;
              list.push({
                id,
                ability,
                abilityId,
                abilityParentId,
                level,
                path,
                remark,
                score,
                sortNum,
              });
            });
            item.list?.forEach((item2) => {
              if (!item2.grade) {
                error.push(`请填写${item2.parentAbility}得分`);
              } else if (!reg.test(item2.grade) || Number(item2.grade) > item2.score || Number(item2.grade) < 0) {
                error.push(`${item2.parentAbility}得分设置不合理`);
              }
              const obj = utils.cloneDeep(item2);
              delete obj.parentAbility;
              delete obj.parentScore;
              delete obj.span;
              list.push(obj);
            });
          });
        }
      }
      // 实物检测
      else {
        if (!info?.testReportAttachPath) {
          error.push('请上传检测报告(pdf格式)');
        }
        if (
          !info?.productTest ||
          !reg.test(info?.productTest) ||
          Number(info?.productTest) > 100 ||
          Number(info?.productTest) < 0
        ) {
          error.push('产品测试分数不合理');
        }
        if (
          !info?.compositeScore ||
          !reg.test(info?.compositeScore) ||
          Number(info?.compositeScore) > 100 ||
          Number(info?.compositeScore) < 0
        ) {
          error.push('综合得分不合理');
        }
        if (!['AAA', 'AA', 'A', 'BBB', 'BB', 'B', 'CCC', 'CC', 'C', '不合格'].includes(info.grade)) {
          error.push('产品质量评级有误，只允许填写AAA、AA、A、BBB、BB、B、CCC、CC、C、不合格，请修改');
        }
        // 结构化
        if (isStructured === '1') {
          const { performanceTableData, tableData } = this.$refs.detection;
          // 检测内容和结果
          applyProductPerformanceAOList = tableData.map((item) => {
            const { detectResult, id, qualifiedSign, detectItem } = item;
            if (![0, 1].includes(qualifiedSign)) {
              error.push(`请选择${detectItem}的合格情况`);
              this.$set(item, 'error', true);
            } else {
              this.$set(item, 'error', false);
            }
            return {
              detectResult,
              evaluationProductPerformanceId: id,
              qualifiedSign,
            };
          });
          // 性能测试
          performanceTableData.forEach((item) => {
            if (item.span) {
              const { scoreName, evaluationProductPerformanceId, realScore, realTestVal, realRemark, score, hidden } =
                item;
              // 没有被隐藏
              if (!hidden) {
                if (!realScore || !reg.test(realScore) || Number(realScore) > Number(score) || Number(realScore) < 0) {
                  error.push(`${scoreName}的分值分配不合理`);
                  this.$set(item, 'error', true);
                } else {
                  this.$set(item, 'error', false);
                }
                applyProductBenchmarkAOList.push({
                  evaluationProductPerformanceId,
                  realScore,
                  realTestVal,
                  remark: realRemark,
                });
              }
            }
          });
        }
      }
      if (error.length) {
        this.$confirm('', '提示', {
          message: error
            .map((item, index) => {
              return `<div>${error.length > 1 ? `${index + 1}、` : ''}${item}</div>`;
            })
            .join(''),
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
        });
      } else {
        const { sceneReportAttachName, sceneReportAttachPath, fieldReview } = info;
        let res = {};
        // 现场审查
        if (this.type === '1') {
          if (isStructured === '0') {
            res = await Api.addUnstructuredApplyGradeScene({
              evaluateItemPriceId,
              evaluationItemId,
              fieldReview,
              sceneReportAttachPath,
              sceneReportAttachName,
              supplierType,
              applyItemPriceId: this.applyItemPriceId,
              applyItemPriceIdSet: this.applyItemPriceIdSet,
            });
          }
          // 结构化
          else {
            res = await Api.submitStructSiteReview({
              applyId,
              evaluateItemPriceId,
              evaluationItemId,
              fieldReview,
              sceneReportAttachPath,
              sceneReportAttachName,
              supplierType,
              submitType,
              applyItemPriceId: this.applyItemPriceId,
              applyItemPriceIdSet: this.applyItemPriceIdSet,
              evaluationProduceAbilityList: list,
            });
          }
        }
        // 实物测试
        else {
          const { compositeScore, grade, productTest, testReportAttachName, testReportAttachPath } = info;
          // 非结构化
          if (isStructured === '0') {
            res = await Api.addUnstructuredApplyGradeTest({
              evaluateItemPriceId,
              evaluationItemId,
              compositeScore,
              grade,
              productTest,
              testReportAttachName,
              testReportAttachPath,
              supplierType,
              applyItemPriceId: this.applyItemPriceId,
              applyItemPriceIdSet: this.applyItemPriceIdSet,
            });
          } else {
            // 实物测试结构化提交
            res = await Api.addStructuredApplyProductTest({
              evaluateItemPriceId,
              evaluationItemId,
              compositeScore,
              grade,
              productTest,
              testReportAttachName,
              testReportAttachPath,
              supplierType,
              applyItemPriceId: this.applyItemPriceId,
              applyItemPriceIdSet: this.applyItemPriceIdSet,
              applyProductBenchmarkAOList,
              applyProductPerformanceAOList,
              remark: this.$refs.detection.remark,
            });
          }
        }
        // 非结构化
        if (res.code === '200') {
          this.$message.success('操作成功');
          this.onCancel();
        }
      }
    },
    onCancel() {
      bus.$emit('close_current_tags');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../components/common';
</style>
<style>
.el-message-box__status {
  display: none !important;
}

.el-message-box__title > span:before {
  font-family: element-icons !important;
  color: #e6a23c;
  content: '\e7a3';
  speak: none;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: middle;
  margin-top: -1px;
  margin-right: 10px;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}
</style>
